<template>
  <div class="app-product-aid-swipe-indicator" :class="`app-product-aid-swipe-indicator--${type}`" :style="{ opacity }">
    <svg v-if="type === 'like'" width="48" height="48" viewBox="0 0 24 24" fill="#4ade80">
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
      />
    </svg>
    <svg v-else width="48" height="48" viewBox="0 0 24 24" fill="#f97316">
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  </div>
</template>

<script setup lang="ts">
  defineProps<{
    type: 'like' | 'dislike';
    opacity: number;
  }>();
</script>

<style lang="postcss" scoped>
  .app-product-aid-swipe-indicator {
    pointer-events: none;

    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    padding: 1rem;
    border-radius: 50%;

    background: rgb(255 255 255 / 90%);

    transition: opacity 0.1s;

    &--like {
      right: 1.5rem;
      box-shadow:
        0 18.02px 22.525px -4.505px rgb(0 0 0 / 10%),
        0 9.01px 9.01px -4.505px rgb(0 0 0 / 4%);
    }

    &--dislike {
      left: 1.5rem;
      box-shadow:
        0 18.02px 22.525px -4.505px rgb(0 0 0 / 10%),
        0 9.01px 9.01px -4.505px rgb(0 0 0 / 4%);
    }
  }
</style>
